/* REACT */
import React, { useEffect, useState } from 'react'

/* 3RD PARTIES */
import { connect } from 'react-redux'
import { useMediaQuery } from 'react-responsive'
import queryString from 'query-string'
import { useNavigate } from 'react-router-dom'

/* COMPONENTS */
import { Spinner } from '../../../components/ui'
import SearchBox from './components/SearchBox'
import SearchAiTextResponse from './components/SearchAiTextResponse'
import DestinationsGridLoader from '../../../components/grids/destinations/Loader'
import TripsGridLoader from '../../../components/grids/trips/Loader'
import EventsGridLoader from '../../../components/grids/events/Loader'
import OthersGridLoader from '../../../components/grids/others/Loader'

/* STORE */
import {
  fetchSearchResults,
  fetchOrganizationDetails,
  setDefaultSearchResults,
  setSearchQuery,
  setGnerateAiQueryResponse,
  setIsFetchingAiQueryResponse,
  sendSearchQueryMessageToMaya,
} from '../../../store/maya/actions'
import { setGeneralConfig } from '../../../store/general/actions'
import { getSearchFilters, getSearchGrids } from '../../../store/maya/selectors'

/* STYLES */
import {
  SearchViewWrapper,
  SearchResultsWrapper,
  SearchLeftGridWrapper,
  SearchGridMobileWrapper,
  EmptyDivWrapper,
  SearchAiTextResponseWrapper,
  ReadMoreWrapper,
  ArrowHead,
  SearchDisableInternalCaseWrapper,
  SearchDisableInternalCaseCta,
  StyledToastContainer,
  NoResults,
} from '../style'

/* UTILS/CONSTANTS/IMAGES-ASSETS */
import { size, CLIENT_STYLINGS } from '../../../utils/constants'
import { getTranslations } from '../../../utils'

const FullSearch = ({
  organizationKey,
  organizationSlug,
  widgetMode,
  chatMode,
  language,
  setGeneralConfig,
  isFetchingSearchResults,
  stateOrganizationSlug,
  stateOrganizationKey,
  stateLanguage,
  stateWidgetMode,
  stateChatMode,
  quickSearches,
  defaultSearchResults,
  setDefaultSearchResults,
  setSearchQuery,
  searchQuery,
  searchAiTextResponse,
  isFetchingAiQueryResponse,
  searchGrids,
  generateAiQueryResponse,
  setGnerateAiQueryResponse,
  setIsFetchingAiQueryResponse,
  isInternalCaseInQueryOrOptions,
  searchFilters,
}) => {
  let navigate = useNavigate()
  const windowSearch = window.location.search
  const [searchParams, setSearchParams] = useState(undefined)

  // const [isConfigSet, setIsConfigSet] = useState(false)
  const [defaultResultsFetched, setDefaultResultsFetched] = useState(false)
  const [isTextExpanded, setIsTextExpanded] = useState(false)
  const [showReadMoreCTA, setShowReadMoreCTA] = useState(false)
  const [selectedTripType, setSelectedTripType] = useState(undefined)
  const [hasAlreadySearched, setHasAlreadySearched] = useState(false)

  const isLessThanLaptop = useMediaQuery({
    query: `(max-width: ${size.laptop})`,
  })

  useEffect(() => {
    // Access the element with id 'maya-b2b-full-page'
    const searchWidgetWrapperElements = document.getElementsByClassName(
      'maya-b2b-search-widget-wrapper'
    )

    // Check if the element exists before manipulating it
    for (let searchWidgetWrapperEl of searchWidgetWrapperElements) {
      // Set the display property to 'unset'
      searchWidgetWrapperEl.style.padding = '10px'
    }

    // THIS IS DONE TO MAKE SEARCHBOX STICKY ON MOBILE
    if (!isLessThanLaptop) return

    // Access the element with id 'maya-b2b-full-page'
    const element1 = document.querySelector(
      '#maya-b2b-full-page[data-widget-mode="search"]'
    )

    // Check if the element exists before manipulating it
    if (element1) {
      // Set the display property to 'unset'
      element1.style.display = 'unset'
    }

    // Access the element with id 'maya-b2b-search-wrapper'
    const searchWrapperElements = document.getElementsByClassName(
      'maya-b2b-search-wrapper'
    )

    for (let searchWrapperEl of searchWrapperElements) {
      // Set the display property to 'unset'
      searchWrapperEl.style.display = 'unset'
    }
  }, [])

  useEffect(() => {
    // Get the div element
    var container = document.getElementById('ai-response-text-container')

    if (!container) {
      setShowReadMoreCTA(false)
      return
    }

    // Get the total height of all content inside the div
    var totalHeight = container.scrollHeight

    // SHOW READ MORE CTA ONLY IF
    // THE CONTENT INSIDE THE TEXT RESPONSE CONTAINER IS GREATER THAN ITS NORMAL HEIGHT ON LESS THAN LAPTOP
    if (isLessThanLaptop && !isTextExpanded && totalHeight > 90) {
      setShowReadMoreCTA(true)
    } else {
      setShowReadMoreCTA(false)
    }
  }, [searchAiTextResponse])

  // useEffect(() => {
  //   if (!isConfigSet && organizationKey && organizationSlug && language) {
  //     setIsConfigSet(true) // JUST SET SOCKET ONE TIME

  //     const { query } = queryString.parseUrl(window.location.search)

  //     // SAVE CREDENTIALS IN STORE
  //     setGeneralConfig({
  //       organizationKey,
  //       organizationSlug,
  //       language: language || 'en',
  //       widgetMode: widgetMode,
  //       chatMode: chatMode, // b2c IS OUR DEFAULT EXISTING CHAT MODE
  //       introType: query?.intro_type || 'default', // default intro type i.e. default messages
  //     })
  //   }
  // }, [])

  const sendSearchRequest = (query, type) => {
    setSearchQuery(query)
    setDefaultSearchResults(false)
    // FETCH SEARCH RESULTS
    fetchSearchResults({
      searchTerm: query,
      numberOfResults: 27,
      tripType: type || null,
    })
    setHasAlreadySearched(true)
  }

  useEffect(() => {
    // NO CHANGE IN QUERY PARAMS RETURN
    if (windowSearch === searchParams) return

    setSearchParams(windowSearch)
    const { query } = queryString.parseUrl(window.location.search)

    const currentTripType = query?.m_tt || query?.trip_type
    const currentSearchQuery = query?.m_q

    setSelectedTripType(currentTripType)
    if (
      (selectedTripType !== currentTripType ||
        (currentSearchQuery && searchQuery != currentSearchQuery)) &&
      currentSearchQuery &&
      stateOrganizationSlug &&
      stateOrganizationKey &&
      stateLanguage &&
      stateWidgetMode &&
      stateChatMode
    ) {
      setSearchQuery(currentSearchQuery)
      setDefaultSearchResults(false)

      // FETCH SEARCH RESULTS AGAIN WHEN QUERY PARAM CHANGED OF TRIP TYPE / SEARCH QUERY
      fetchSearchResults({
        searchTerm: currentSearchQuery,
        numberOfResults: 27,
        tripType: currentTripType || null,
      })

      setHasAlreadySearched(true)
    }
  }, [
    windowSearch, // LOOK FOR CHANGES IN WINDOW SEARCH PARAMS
  ])

  useEffect(() => {
    // HOOK HANDLING FOR FETCHING ORGANIZATION DETAILS

    if (
      stateOrganizationSlug &&
      stateOrganizationKey &&
      stateLanguage &&
      stateWidgetMode &&
      stateChatMode &&
      !defaultResultsFetched
    ) {
      const { query } = queryString.parseUrl(window.location.search)

      // SET TRIP TYPE IF IT EXISTS IN URL QUERY
      if (query?.m_tt) {
        setSelectedTripType(query?.m_tt)
      } else if (query?.trip_type) {
        setSelectedTripType(query?.trip_type)
      }

      setDefaultResultsFetched(true)
      // // FETCH ORGANIZATION DETAILS
      // fetchOrganizationDetails()

      if (query.m_q && searchQuery != query.m_q) {
        // IF AT THE START OF APP SEARCH QUERY EXISTS IN URL SEARCH BASED UPON IT
        sendSearchRequest(query.m_q, query.m_tt || query.trip_type)
      }
    }
  }, [
    stateOrganizationSlug,
    stateOrganizationKey,
    stateLanguage,
    stateWidgetMode,
  ])

  const handleSearchQueryChange = query => {
    setSearchQuery(query)
  }

  const onSearchSubmit = searchTerm => {
    // ON SEARCH SUBMIT CALL THE SEND SEARCH FUNCTION AND ALSO ADD THE NEW QUERY IN URL
    sendSearchRequest(searchTerm, selectedTripType)

    // Update the URL with the new search query (without reloading the page)
    const url = new URL(window.location)
    url.searchParams.set('m_q', searchTerm)
    window.history.pushState({ path: url.href }, '', url.href)
  }

  const removeSelectedTripType = () => {
    navigate('/')
  }

  const getSearchGridsMobile = () => {
    if (!searchGrids) {
      return null
    }

    let itemsToReturn = Object.keys(searchGrids).map((keyName, i) => {
      if (keyName === 'destinations') {
        return (
          <DestinationsGridLoader
            id={searchGrids?.destinations?.id}
            title={searchGrids?.destinations?.title || ''}
            items={searchGrids?.destinations?.items || []}
            isLessThanLaptop={isLessThanLaptop}
            language={language}
            organizationSlug={organizationSlug}
            itemsPerRow={3}
            itemsPerPage={9}
          />
        )
      }
      if (keyName === 'trips') {
        return (
          <TripsGridLoader
            id={searchGrids?.trips?.id}
            items={searchGrids?.trips?.items || []}
            title={searchGrids?.trips?.title || ''}
            isLessThanLaptop={isLessThanLaptop}
            language={language}
            organizationSlug={organizationSlug}
            itemsPerRow={3}
            itemsPerPage={9}
            isChatMode={false}
          />
        )
      }
      if (keyName === 'events') {
        return (
          <EventsGridLoader
            id={searchGrids?.events?.id}
            title={searchGrids?.events?.title || ''}
            items={searchGrids?.events?.items || []}
            isLessThanLaptop={isLessThanLaptop}
            language={language}
            organizationSlug={organizationSlug}
            itemsPerRow={3}
            itemsPerPage={9}
          />
        )
      }
      if (keyName === 'others') {
        return (
          <OthersGridLoader
            id={searchGrids?.others?.id}
            title={searchGrids?.others?.title || ''}
            items={searchGrids?.others?.items || []}
            isLessThanLaptop={isLessThanLaptop}
            language={language}
            organizationSlug={organizationSlug}
            itemsPerRow={3}
            itemsPerPage={9}
          />
        )
      }
    })

    return itemsToReturn
  }
  const getSearchMobileView = () => {
    return (
      <>
        <SearchGridMobileWrapper>
          <StyledToastContainer hideProgressBar={true} />
          <EmptyDivWrapper></EmptyDivWrapper>
          <SearchBox
            onSearchSubmit={onSearchSubmit}
            isLessThanLaptop={isLessThanLaptop}
            language={language}
            quickSearches={quickSearches || null}
            handleQuickSearch={onSearchSubmit}
            defaultSearchResults={defaultSearchResults}
            handleSearchQueryChange={handleSearchQueryChange}
            searchQuery={searchQuery}
            organizationSlug={stateOrganizationSlug}
            selectedTripType={selectedTripType}
            removeSelectedTripType={removeSelectedTripType}
            filters={searchFilters}
          />
          {!isFetchingSearchResults &&
          hasAlreadySearched &&
          !searchGrids?.events?.items?.length &&
          !searchGrids?.others?.items?.length &&
          !searchGrids?.trips?.items?.length &&
          !searchGrids?.destinations?.items?.length ? (
            <NoResults>{getTranslations('no_search_results')}</NoResults>
          ) : null}
          {!defaultSearchResults && generateAiQueryResponse ? (
            <SearchAiTextResponseWrapper id='maya-search-ai-text-response-wrapper'>
              <SearchAiTextResponse
                isTyping={isFetchingSearchResults || isFetchingAiQueryResponse}
                textResponse={searchAiTextResponse}
                isTextExpanded={isTextExpanded}
                isLessThanLaptop={isLessThanLaptop}
                language={language}
              />
              {!isFetchingSearchResults && showReadMoreCTA ? (
                <ReadMoreWrapper
                  onClick={() => {
                    setIsTextExpanded(!isTextExpanded)
                  }}
                >
                  {isTextExpanded
                    ? getTranslations('read_less')
                    : getTranslations('read_more')}{' '}
                  &nbsp;
                  <ArrowHead down={!isTextExpanded}>&#8963;</ArrowHead>
                </ReadMoreWrapper>
              ) : null}
            </SearchAiTextResponseWrapper>
          ) : null}

          {!generateAiQueryResponse && isInternalCaseInQueryOrOptions ? (
            <SearchDisableInternalCaseWrapper>
              <SearchDisableInternalCaseCta
                onClick={() => {
                  setGnerateAiQueryResponse(true)
                  setIsFetchingAiQueryResponse(true)
                  sendSearchQueryMessageToMaya()
                }}
              >
                {getTranslations('generate_ai_response_cta')}
              </SearchDisableInternalCaseCta>
            </SearchDisableInternalCaseWrapper>
          ) : null}

          <SearchResultsWrapper id='search-results-wrapper'>
            {isFetchingSearchResults ? (
              <div
                style={{
                  width: '100%',
                  height: '100%',
                  backgroundColor:
                    CLIENT_STYLINGS[organizationSlug].COLOR.BACKGROUND,
                  opacity: '0.8',
                  zIndex: '100',
                  position: 'absolute',
                  minHeight: '300px',
                }}
                id={'search-grid-spinner'}
              >
                <Spinner
                  isBasic={false}
                  interval={10000}
                  messages={getTranslations('fetching_search')}
                  marginTop={'100px'}
                  justifyContent={'start'}
                />
              </div>
            ) : null}

            {getSearchGridsMobile()}
            <EmptyDivWrapper></EmptyDivWrapper>
          </SearchResultsWrapper>
        </SearchGridMobileWrapper>
      </>
    )
  }

  const getSearchGridsDesktop = () => {
    if (!searchGrids) {
      return null
    }

    let itemsToReturn = Object.keys(searchGrids).map((keyName, i) => {
      if (keyName === 'destinations') {
        return (
          <DestinationsGridLoader
            id={searchGrids?.destinations?.id}
            title={searchGrids?.destinations?.title || ''}
            items={searchGrids?.destinations?.items || []}
            isLessThanLaptop={isLessThanLaptop}
            language={language}
            organizationSlug={organizationSlug}
            itemsPerRow={3}
            itemsPerPage={9}
          />
        )
      }
      if (keyName === 'trips') {
        return (
          <TripsGridLoader
            id={searchGrids?.trips?.id}
            items={searchGrids?.trips?.items || []}
            title={searchGrids?.trips?.title || ''}
            isLessThanLaptop={isLessThanLaptop}
            language={language}
            organizationSlug={organizationSlug}
            itemsPerRow={3}
            itemsPerPage={9}
            isChatMode={false}
          />
        )
      }
      if (keyName === 'events') {
        return (
          <EventsGridLoader
            id={searchGrids?.events?.id}
            title={searchGrids?.events?.title || ''}
            items={searchGrids?.events?.items || []}
            isLessThanLaptop={isLessThanLaptop}
            language={language}
            organizationSlug={organizationSlug}
            itemsPerRow={3}
            itemsPerPage={9}
          />
        )
      }
      if (keyName === 'others') {
        return (
          <OthersGridLoader
            id={searchGrids?.others?.id}
            title={searchGrids?.others?.title || ''}
            items={searchGrids?.others?.items || []}
            isLessThanLaptop={isLessThanLaptop}
            language={language}
            organizationSlug={organizationSlug}
            itemsPerRow={3}
            itemsPerPage={9}
          />
        )
      }
    })

    return itemsToReturn
  }

  const getSearchDesktopView = () => {
    return (
      <>
        <SearchLeftGridWrapper id='maya-search-left-grid-wrapper'>
          <StyledToastContainer hideProgressBar={true} />
          <SearchBox
            onSearchSubmit={onSearchSubmit}
            isLessThanLaptop={isLessThanLaptop}
            language={language}
            quickSearches={quickSearches || null}
            handleQuickSearch={onSearchSubmit}
            defaultSearchResults={defaultSearchResults}
            handleSearchQueryChange={handleSearchQueryChange}
            searchQuery={searchQuery}
            organizationSlug={stateOrganizationSlug}
            selectedTripType={selectedTripType}
            removeSelectedTripType={removeSelectedTripType}
            filters={searchFilters}
          ></SearchBox>
          {!isFetchingSearchResults &&
          hasAlreadySearched &&
          !searchGrids?.events?.items?.length &&
          !searchGrids?.others?.items?.length &&
          !searchGrids?.trips?.items?.length &&
          !searchGrids?.destinations?.items?.length ? (
            <NoResults>{getTranslations('no_search_results')}</NoResults>
          ) : null}

          <SearchResultsWrapper id='search-results-wrapper'>
            {isFetchingSearchResults ? (
              <div
                style={{
                  width: '100%',
                  height: '100%',
                  backgroundColor:
                    CLIENT_STYLINGS[organizationSlug].COLOR.BACKGROUND,
                  opacity: '0.8',
                  zIndex: '100',
                  position: 'absolute',
                  minHeight: '300px',
                }}
                id={'search-grid-spinner'}
              >
                <Spinner
                  isBasic={false}
                  interval={10000}
                  messages={getTranslations('fetching_search')}
                  marginTop={'100px'}
                  justifyContent={'start'}
                />
              </div>
            ) : null}
            {getSearchGridsDesktop()}
          </SearchResultsWrapper>
        </SearchLeftGridWrapper>
        {!defaultSearchResults && generateAiQueryResponse ? (
          <SearchAiTextResponseWrapper id='maya-search-ai-text-response-wrapper'>
            <SearchAiTextResponse
              isTyping={isFetchingSearchResults || isFetchingAiQueryResponse}
              textResponse={searchAiTextResponse}
              language={language}
            />
          </SearchAiTextResponseWrapper>
        ) : null}
        {!generateAiQueryResponse && isInternalCaseInQueryOrOptions ? (
          <SearchDisableInternalCaseWrapper>
            <SearchDisableInternalCaseCta
              onClick={() => {
                setGnerateAiQueryResponse(true)
                setIsFetchingAiQueryResponse(true)
                sendSearchQueryMessageToMaya()
              }}
            >
              {getTranslations('generate_ai_response_cta')}
            </SearchDisableInternalCaseCta>
          </SearchDisableInternalCaseWrapper>
        ) : null}
      </>
    )
  }

  return (
    <SearchViewWrapper
      id='maya-search-view-wrapper'
      style={
        isFetchingSearchResults ? { overflow: 'hidden', height: '100vh' } : {}
      }
    >
      {stateOrganizationSlug
        ? isLessThanLaptop
          ? getSearchMobileView()
          : getSearchDesktopView()
        : null}
    </SearchViewWrapper>
  )
}

const mapStateToProps = state => ({
  stateOrganizationSlug: state.general.organizationSlug,
  stateOrganizationKey: state.general.organizationKey,
  stateLanguage: state.general.language,
  stateWidgetMode: state.general.widgetMode,
  stateChatMode: state.general.chatMode,
  quickSearches: state.maya.quickSearches,
  defaultSearchResults: state.maya.defaultSearchResults,
  searchQuery: state.maya.searchQuery,
  searchAiTextResponse: state.maya.searchAiTextResponse,
  isFetchingSearchResults: state.maya.isFetchingSearchResults,
  isFetchingAiQueryResponse: state.maya.isFetchingAiQueryResponse,
  searchGrids: getSearchGrids(state),
  generateAiQueryResponse: state.maya.generateAiQueryResponse,
  isInternalCaseInQueryOrOptions: state.maya.isInternalCaseInQueryOrOptions,
  searchFilters: getSearchFilters(state),
})

const mapDispatchToProps = dispatch => ({
  setGeneralConfig: config => dispatch(setGeneralConfig(config)),
  setDefaultSearchResults: value => dispatch(setDefaultSearchResults(value)),
  setSearchQuery: query => dispatch(setSearchQuery(query)),
  setGnerateAiQueryResponse: value =>
    dispatch(setGnerateAiQueryResponse(value)),
  setIsFetchingAiQueryResponse: value =>
    dispatch(setIsFetchingAiQueryResponse(value)),
})

export default connect(mapStateToProps, mapDispatchToProps)(FullSearch)
